import { render, staticRenderFns } from "./OverallResults.vue?vue&type=template&id=72fdf45a&scoped=true&"
import script from "./OverallResults.vue?vue&type=script&lang=js&"
export * from "./OverallResults.vue?vue&type=script&lang=js&"
import style0 from "./OverallResults.vue?vue&type=style&index=0&id=72fdf45a&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fdf45a",
  null
  
)

export default component.exports